import React from "react";

import _ from "lodash";

import { AttachmentType } from "components/ui/AttachmentPicker";

import { DesktopOrMobile } from "types/enums";

import { calculateStatus, createAttachmentType } from "utils/utils";

function useMobileOrDesktopFile({
    setForm,
    path,
}: {
    setForm: React.Dispatch<React.SetStateAction<any>>;
    path: string;
}) {
    const setDesktopMobileImage = React.useCallback(
        (fileToSet: AttachmentType, target: DesktopOrMobile) => {
            if (path) {
                setForm((prevForm: any) => {
                    const newForm = _.cloneDeep(prevForm);

                    if (target === DesktopOrMobile.desktop || target === DesktopOrMobile.mobile) {
                        if (fileToSet && newForm[path][target]) {
                            newForm[path][target] = createAttachmentType({
                                filename: fileToSet.filename,
                                content: fileToSet.content,
                                contentType: fileToSet.contentType ?? "",
                                size: fileToSet.size,
                                label: fileToSet.label,
                                status: calculateStatus(fileToSet.filename, fileToSet.content),
                            });
                        } else if (newForm[path][target]) {
                            newForm[path][target] = createAttachmentType({
                                label: "not_present",
                                status: 0,
                            });
                        }
                    }

                    return newForm;
                });
            }
        },
        [setForm, path]
    );

    return React.useMemo(() => ({ setDesktopMobileImage }), [setDesktopMobileImage]);
}

export default useMobileOrDesktopFile;
